// @ts-ignore
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ModalFilter from 'components/Granel/new-notas/Filter/Modal';
import { List } from 'components/Granel/new-notas/Item';
import ModalContent from 'components/Granel/new-notas/Modal';
import PaginationComponent from 'components/layout/Pagination';
import 'intro.js/introjs.css';
import { Steps } from 'intro.js-react';
import scrollBlock from 'utils/functions/scrollBlock';

import {
  ModalOrganizationCloseIcon,
  ModalOrganizationContainer,
  ModalOrganizationContent,
  ModalOrganizationHeader,
  ModalOrganizationIcon,
  ModalOrganizationItem,
  ModalOrganizationLeft,
  ModalOrganizationModalTitle,
  ModalOrganizationSeparator,
  ModalOrganizationTitle,
  StyledModal,
  ItemIcon,
  ReceiptIcon,
} from 'components/Granel/new-notas/Organization/styles';
import Loading from 'components/layout/loading';
import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import api from 'services/api';
import { verifyUser } from 'utils/functions';
import { insertScrollTop } from 'utils/scroll';
import { useTour } from 'hooks/useTour';
import { TableWrap } from 'pages/BankSlip/styles';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import {
  BoxPadding,
  ButtonsContainer,
  ClearButton,
  FilterButton,
  FilterIcon,
  FilterText,
  HeaderPage,
  Hr,
  Scrollbar,
  SortButton,
  SortIcon,
  Table,
  Tbody,
  Th,
  Thead,
  Title,
  SortArrow,
  ListForDownload,
  ActionsButton,
  SelectedItem,
  SelectedText,
  DropdownSeparator,
} from './styles';

const Notas = (props) => {
  const [payments, setPayments] = useState([]);
  const [installments, setInstallments] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(1);
  const [bankSlips, setBankSlips] = useState([]);
  const [hasFilter, setHasFilter] = useState(false);
  const [modalFilter, setModalFilter] = useState(false);
  const [modalOrganization, setModalOrganization] = useState(false);
  const [orderBy, setOrderBy] = useState('emissionDate DESC');
  const [pageTotal, setPageTotal] = useState(0);
  const [activeModeDownload, setActiveModeDownload] = useState(true);
  const [invoicesForDownload, setInvoicesForDownload] = useState([]);
  const [invoiceSelected, setInoicesSelected] = useState(null);
  const [selectAllInvoices, setSelectAllInvoices] = useState(false);
  const [stepResponsive, setResponsive] = useState(false);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [modalPayment, setModalPayment] = useState();
  const [modalInstallments, setModalInstallments] = useState();

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    applyFilterAndRequestInvoices();
  }, [activePage, orderBy]);

  useEffect(() => {
    setTourType('invoices');
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  const organizeBankSlips = async (response) => {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const filterStatus = await params.get('status');
    const beginDate = await params.get('begin-date');
    const endDate = await params.get('end-date');
    let bankSlipsForEdited = [];

    response.map((invoice) =>
      invoice.installments.forEach((installment) => {
        bankSlipsForEdited = [...bankSlipsForEdited, { installment, invoice }];
      })
    );
    setBankSlips(bankSlipsForEdited);
  };

  const requestInvoices = (
    token,
    invoiceNumber,
    beginAmount,
    endAmount,
    beginDate,
    endDate
  ) => {
    const customerCode = localStorage.getItem(
      '@UltragazEmpresarial:customerCode'
    );
    const customerSiteCode = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };

    let url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=10&_offset=${
      activePage - 1
    }&_order_by=${orderBy}`;

    if (
      beginDate &&
      endDate &&
      invoiceNumber === null &&
      beginAmount === null &&
      endAmount === null
    ) {
      url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=10&_offset=${
        activePage - 1
      }&_order_by=${orderBy}&begin-date=${beginDate}&end-date=${endDate}`;
    }

    // Verifica se tem nº da nota e data
    if (
      invoiceNumber &&
      beginDate &&
      endDate &&
      beginAmount === null &&
      endAmount === null
    ) {
      url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=10&_offset=${
        activePage - 1
      }&_order_by=${orderBy}&begin-date=${beginDate}&end-date=${endDate}&invoice-number=${invoiceNumber}`;
    }

    // Verifica se tem valor da nota e data
    if (
      beginAmount &&
      endAmount &&
      beginDate &&
      endDate &&
      invoiceNumber === null
    ) {
      url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=10&_offset=${
        activePage - 1
      }&_order_by=${orderBy}&begin-date=${beginDate}&end-date=${endDate}&begin-amount=${beginAmount}&end-amount=${endAmount}`;
    }

    // Verifica se tem valor da nota, numero da nota e data
    if (beginAmount && endAmount && invoiceNumber && beginDate && endDate) {
      url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=10&_offset=${
        activePage - 1
      }&_order_by=${orderBy}&begin-date=${beginDate}&end-date=${endDate}&&begin-amount=${beginAmount}&end-amount=${endAmount}&invoice-number=${invoiceNumber}`;
    }

    // Verifica se tem valor da nota e numero da nota
    if (
      beginAmount &&
      endAmount &&
      invoiceNumber &&
      beginDate === null &&
      endDate === null
    ) {
      url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=10&_offset=${
        activePage - 1
      }&_order_by=${orderBy}&&begin-amount=${beginAmount}&end-amount=${endAmount}&invoice-number=${invoiceNumber}`;
    }

    // Verifica se tem valor da nota
    if (
      beginAmount &&
      endAmount &&
      beginDate === null &&
      endDate === null &&
      invoiceNumber === null
    ) {
      url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=10&_offset=${
        activePage - 1
      }&_order_by=${orderBy}&&begin-amount=${beginAmount}&end-amount=${endAmount}`;
    }

    // Verifica se tem numero da nota
    if (
      invoiceNumber &&
      beginDate === null &&
      endDate === null &&
      beginAmount === null &&
      endAmount === null
    ) {
      url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=10&_offset=${
        activePage - 1
      }&_order_by=${orderBy}&invoice-number=${invoiceNumber}`;
    }

    api
      .get(url, parameters)
      .then((res) => {
        const pageTotalReturn = res.headers['total-pages'];
        setPageTotal(pageTotalReturn);
        setLoading(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.length >= 1) {
            setPayments(response);
            setInstallments(response);
            organizeBankSlips(response);
          }
          organizeBankSlips(response);
        }
      })
      .catch((err) => {
        setLoading(false);
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  const applyFilterAndRequestInvoices = useCallback(async () => {
    setLoading(true);
    const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const beginDate = await params.get('begin-date');
    const endDate = await params.get('end-date');
    const filterStatus = await params.get('status');
    const invoiceNumber = await params.get('invoice-number');
    const beginAmount = await params.get('begin-amount');
    const endAmount = await params.get('end-amount');
    const customerCode = localStorage.getItem(
      '@UltragazEmpresarial:customerCode'
    );
    const customerSiteCode = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );

    if (invoiceNumber) {
      setHasFilter(true);
    }
    if (beginAmount && endAmount) {
      setHasFilter(true);
    }
    if (beginDate && endDate) {
      setHasFilter(true);
    }
    if (token) {
      requestInvoices(
        token,
        invoiceNumber,
        beginAmount,
        endAmount,
        beginDate,
        endDate
      );
    } else {
      verifyUser(props);
    }
  }, [requestInvoices, verifyUser, setHasFilter, setLoading]);

  const setStepResponsive = () => {
    setStepResponsive(window.matchMedia('(max-width: 1100px)').matches);
  };

  const clearFilter = () => {
    window.location.href = '/notas';
  };

  const clearSelectAllInvoices = () => {
    setSelectAllInvoices(false);
    setInvoicesForDownload([]);
  };

  const setSelectAllInvoicesFunc = () => {
    setSelectAllInvoices(!selectAllInvoices);
    setInvoicesForDownload([]);
    if (!selectAllInvoices) {
      const array = bankSlips
        .filter((item) => {
          if (
            (item.invoice.source === 'COLETORES' ||
              item.invoice.source === 'NFF') &&
            item.invoice.accessKey !== undefined
          ) {
            return item.invoice.invoiceId !== undefined;
          }
        })
        .map((item) => {
          return item.invoice.invoiceId;
        });
      setInvoicesForDownload(array);
    }

    if (selectAllInvoices) {
      setInvoicesForDownload([]);
    }
  };

  const selectInvoicesForDownload = (invoiceId, source, accessKey) => {
    if (source === 'COLETORES' && accessKey !== undefined) {
      if (selectAllInvoices) {
        setSelectAllInvoices(false);
        setInvoicesForDownload(invoiceId);
      }
      if (invoicesForDownload.indexOf(invoiceId) > -1) {
        const array = this.state.invoicesForDownload;
        const index = array.indexOf(invoiceId);
        array.splice(index, 1);
        setInvoicesForDownload(array);
      } else {
        setInvoicesForDownload([...invoicesForDownload, invoiceId]);
      }
    }
  };

  const requestDownload = (method) => {
    setLoading(true);
    const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
    const customerCode = localStorage.getItem(
      '@UltragazEmpresarial:customerCode'
    );
    const customerSiteCode = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );
    const email = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      responseType: 'blob',
      headers: header,
    };
    const body = {
      customerCode,
      customerSiteCode,
      deliveryMethod: method,
      email,
      invoice: {
        documentType: 'DANFE',
        ids: [...invoicesForDownload],
      },
    };
    api
      .post('/industrial/invoice/v1/duplicates', body, parameters)
      .then((response) => {
        if (method === 'DOWNLOAD') {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `ultra_${body.invoice.ids.length}_notas_fiscais.zip`
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          toast.success('Notas baixadas. Confira sua pasta de downloads.');
        }
        if (method === 'EMAIL') {
          toast.success('As notas foram enviadas para o seu e-mail.');
        }
        clearSelectAllInvoices();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        clearSelectAllInvoices();
        toast.error(err.message);
      });
  };

  const handleOrganization = (bankSlipsParam, organizationType) => {
    if (organizationType === 'maiorValor') {
      setOrderBy('amountOriginal DESC');
    } else if (organizationType === 'menorValor') {
      setOrderBy('amountOriginal ASC');
    } else if (organizationType === 'notaMaior') {
      setOrderBy('invoiceNumber DESC');
    } else if (organizationType === 'notaMenor') {
      setOrderBy('invoiceNumber ASC');
    } else if (organizationType === 'maiorData') {
      setOrderBy('emissionDate DESC');
    } else if (organizationType === 'menorData') {
      setOrderBy('emissionDate ASC');
    }
    setBankSlips(bankSlipsParam);
    setModalOrganization(false);
  };

  const handleShow = (paymentParam, installmentsParam) => {
    if (paymentParam && installmentsParam) {
      setModalPayment(paymentParam);
      setModalInstallments(installmentsParam);
      setShowModal(true);
    }
  };

  const getStatus = (installment) => {
    const currentDate = new Date();
    const dueDate = new Date(installment.dueDate);
    let status;
    dueDate.setDate(dueDate.getDate() + 1);
    if (installment.paymentStatus === 'OP') {
      if (currentDate > dueDate) status = 'Vencido';
      if (currentDate <= dueDate) status = 'A vencer';
    } else {
      status = 'Pago';
    }
    return status;
  };

  const goTop = () => {
    const width = window.innerWidth;
    if (width <= 455) {
      insertScrollTop(220);
    } else {
      insertScrollTop(200);
    }
  };

  const handleChangePage = (pageNumber) => {
    setActivePage(pageNumber);
    goTop();
  };

  const onExit = () => {
    setStepsEnabled(false);
    scrollBlock('#outer-container', 'body', false);
  };

  const toggleSteps = () => {
    setStepResponsive();
    setStepsEnabled(!stepsEnabled);
    scrollBlock('#outer-container', 'body', true);
  };

  console.log({ bankSlips });

  return (
    <>
      <Navbar selected="notas" withTable>
        <UserMenu breadcrump="› Notas Fiscais" intro={toggleSteps} />
        <Scrollbar>
          <BoxPadding>
            <HeaderPage>
              <Title>Notas</Title>
              {activeModeDownload && invoicesForDownload.length >= 1 && (
                <span className="selected-download-message">
                  <b>
                    {`Você selecionou ${invoicesForDownload.length}
                      ${invoicesForDownload.length > 1 ? 'notas' : 'nota'}.`}
                  </b>
                </span>
              )}
              <ButtonsContainer>
                <SortButton onClick={() => setModalOrganization(true)}>
                  <SortIcon className="mdi mdi-swap-vertical" />
                  Ordenar
                </SortButton>
                {invoicesForDownload.length >= 1 && (
                  <ActionsButton menuAlign="left" id="dropdown-mobile-order">
                    <ActionsButton.Toggle id="ActionsButton">
                      {activeModeDownload &&
                        invoicesForDownload.length >= 1 && (
                          <>
                            {` Baixar/enviar notas`}
                            <span id="for-mail">{`  por e-mail `}</span>
                          </>
                        )}
                    </ActionsButton.Toggle>

                    <ActionsButton.Menu>
                      <ActionsButton.Item
                        onClick={() => clearSelectAllInvoices()}
                      >
                        <span className="mdi mdi-close" />
                        {` Cancelar Seleção `}
                      </ActionsButton.Item>

                      {activeModeDownload &&
                        invoicesForDownload.length >= 1 && (
                          <>
                            <DropdownSeparator />
                            <ActionsButton.Item
                              onClick={() => requestDownload('DOWNLOAD')}
                            >
                              <span className="mdi mdi-download" />
                              {`Baixar ${invoicesForDownload.length}
                                ${
                                  invoicesForDownload.length > 1
                                    ? 'notas'
                                    : 'nota'
                                }`}
                            </ActionsButton.Item>
                            <DropdownSeparator />
                            <ActionsButton.Item
                              onClick={() => requestDownload('EMAIL')}
                            >
                              <span className="mdi mdi-email" />
                              {` Enviar ${invoicesForDownload.length}
                                ${
                                  invoicesForDownload.length > 1
                                    ? 'notas'
                                    : 'nota'
                                } por e-mail`}
                            </ActionsButton.Item>
                          </>
                        )}
                    </ActionsButton.Menu>
                  </ActionsButton>
                )}

                <FilterButton onClick={() => setModalFilter(true)}>
                  <FilterIcon />
                  <FilterText>Filtrar</FilterText>
                </FilterButton>

                {hasFilter ? (
                  <ClearButton onClick={() => clearFilter()}>
                    <SortIcon className="mdi mdi-close" />
                    Limpar Filtros
                  </ClearButton>
                ) : null}
              </ButtonsContainer>
            </HeaderPage>

            <Hr />
          </BoxPadding>
          <TableWrap
            showTour={showTour && tourType === 'invoices' && tourStep === 1}
          >
            <Table className="intro-notas">
              {activeModeDownload && (
                <>
                  <SelectedItem
                    id="selected-mobile"
                    selectAllInvoices={selectAllInvoices}
                    marginThead
                    onClick={() => setSelectAllInvoicesFunc()}
                  />
                  <span id="text-selected">{` Selecionar todas as notas`}</span>
                </>
              )}
              <Thead id="headerTable">
                <Th style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <>
                    {activeModeDownload && (
                      <SelectedItem
                        selectAllInvoices={selectAllInvoices}
                        marginThead
                        onClick={() => setSelectAllInvoicesFunc()}
                      />
                    )}
                    <SelectedText>
                      <span>Emissão</span>
                    </SelectedText>

                    <SortArrow
                      onClick={() => handleOrganization(bankSlips, 'maiorData')}
                      className="mdi mdi-arrow-up ml-2"
                      aria-label="Ordenar emissão pela maior data"
                    />
                    <SortArrow
                      onClick={() => handleOrganization(bankSlips, 'menorData')}
                      className="mdi mdi-arrow-down ml-2"
                      aria-label="Ordenar emissão pela menor data"
                    />
                  </>
                </Th>
                <Th style={{ display: 'flex', justifyContent: 'center' }}>
                  <SelectedText>
                    <span>Valor</span>
                  </SelectedText>
                  <SortArrow
                    onClick={() => handleOrganization(bankSlips, 'maiorValor')}
                    className="mdi mdi-arrow-up ml-2"
                    aria-label="Ordenar valor pelo maior valor"
                  />
                  <SortArrow
                    onClick={() => handleOrganization(bankSlips, 'menorValor')}
                    className="mdi mdi-arrow-down ml-2"
                    aria-label="Ordenar valor pelo menor valor"
                  />
                </Th>
                <Th style={{ display: 'flex', justifyContent: 'center' }}>
                  <SelectedText>
                    <span>Nº da Nota</span>
                  </SelectedText>
                  <SortArrow
                    onClick={() => handleOrganization(bankSlips, 'notaMaior')}
                    className="mdi mdi-arrow-up ml-2"
                    aria-label="Ordenar Nota pelo maior número"
                  />
                  <SortArrow
                    onClick={() => handleOrganization(bankSlips, 'notaMenor')}
                    className="mdi mdi-arrow-down ml-2"
                    aria-label="Ordenar Nota pelo menor número"
                  />
                </Th>
                <Th style={{ display: 'flex', justifyContent: 'center' }}>
                  2ª via Nota
                </Th>
              </Thead>
              <Tbody>
                {bankSlips.length > 0 ? (
                  bankSlips.map((bankslip, index) => {
                    const { invoice, installment } = bankslip;
                    return (
                      <>
                        <ListForDownload
                          isSelected={
                            invoicesForDownload.indexOf(invoice.invoiceId) >=
                              0 && true
                          }
                          selectAllInvoices={selectAllInvoices}
                          disponibleForDownload={
                            !!(
                              (invoice.source === 'COLETORES' ||
                                invoice.source === 'NFF') &&
                              invoice.accessKey !== undefined
                            )
                          }
                        >
                          <List
                            open={() => handleShow(invoice, invoice)}
                            selectItem={() => {
                              selectInvoicesForDownload(
                                invoice.invoiceId,
                                invoice.source,
                                invoice.accessKey
                              );
                            }}
                            installment={installment}
                            invoice={invoice}
                            status={getStatus(installment)}
                            activeModeDownload={activeModeDownload}
                            selectedItem={
                              invoicesForDownload.indexOf(invoice.invoiceId) >=
                                0 && true
                            }
                            selectAllInvoices={selectAllInvoices}
                            disponibleForDownload={
                              !!(
                                (invoice.source === 'COLETORES' ||
                                  invoice.source === 'NFF') &&
                                invoice.accessKey !== undefined
                              )
                            }
                          />
                        </ListForDownload>
                      </>
                    );
                  })
                ) : (
                  <p style={{ marginLeft: 20, fontSize: 18 }}>
                    {() => {
                      if (loading) return 'Carregando...';
                      if (hasFilter)
                        return 'Você não possui notas para esse filtro!';
                      return 'Você não possui notas!';
                    }}
                  </p>
                )}
              </Tbody>
            </Table>
            {showTour && tourType === 'invoices' && tourStep === 1 && (
              <TourBalloon
                title="Notas fiscais"
                content="Aqui você encontra todas suas notas fiscais. Você poderá baixá-las, imprimí-las ou enviá-las por e-mail."
                position={{
                  left: '50%',
                  right: '0',
                  top: '-187px',
                  arrowPosition: 'bottom',
                  maxWidth: 'unset',
                  boxShadow: false,
                  width: '492px',
                  transform: 'translateX(-50%)',
                }}
              />
            )}
          </TableWrap>
          {bankSlips.length > 0 && pageTotal > 0 && (
            <PaginationComponent
              totalPages={pageTotal}
              isLoading={loading}
              selectedPage={activePage}
              onPageChange={handleChangePage}
            />
          )}
        </Scrollbar>
      </Navbar>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalContent
          close={() => setShowModal(false)}
          payment={modalPayment}
          installment={modalInstallments}
        />
      </Modal>
      <StyledModal
        show={modalFilter}
        onHide={() => setModalFilter(false)}
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalFilter close={() => setModalFilter(false)} />
      </StyledModal>
      <Modal
        show={modalOrganization}
        onHide={() => setModalOrganization(false)}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalOrganizationContainer>
          <ModalOrganizationHeader>
            <ModalOrganizationLeft>
              <ModalOrganizationModalTitle>Ordenar</ModalOrganizationModalTitle>
            </ModalOrganizationLeft>
            <ModalOrganizationCloseIcon
              title="Fechar"
              className="mdi mdi-close mdi-24px"
              onClick={() => setModalOrganization(false)}
            />
          </ModalOrganizationHeader>

          <ModalOrganizationContent>
            <ModalOrganizationItem className="mt-4">
              <ModalOrganizationTitle>
                <div className="d-flex flex-row align-items-center">
                  <ItemIcon
                    className="mdi mdi-calendar-blank-outline"
                    aria-hidden="true"
                  />
                  Data
                </div>
              </ModalOrganizationTitle>
              <div>
                <ModalOrganizationIcon
                  className="mdi mdi-arrow-up ml-2"
                  onClick={() => handleOrganization(bankSlips, 'maiorData')}
                />
                <ModalOrganizationIcon
                  className="mdi mdi-arrow-down ml-2"
                  onClick={() => handleOrganization(bankSlips, 'menorData')}
                />
              </div>
            </ModalOrganizationItem>
            <ModalOrganizationItem className="mt-4">
              <ModalOrganizationTitle>
                <div className="d-flex flex-row align-items-center">
                  <ItemIcon
                    className="mdi mdi-currency-usd"
                    aria-hidden="true"
                  />
                  Valor
                </div>
              </ModalOrganizationTitle>
              <div>
                <ModalOrganizationIcon
                  className="mdi mdi-arrow-up ml-2"
                  onClick={() => handleOrganization(bankSlips, 'maiorValor')}
                />
                <ModalOrganizationIcon
                  className="mdi mdi-arrow-down ml-2"
                  onClick={() => handleOrganization(bankSlips, 'menorValor')}
                />
              </div>
            </ModalOrganizationItem>
            <ModalOrganizationItem className="mt-4">
              <ModalOrganizationTitle>
                <div className="d-flex flex-row align-items-center">
                  <ReceiptIcon aria-hidden="true" />
                  Nº da Nota
                </div>
              </ModalOrganizationTitle>
              <div>
                <ModalOrganizationIcon
                  className="mdi mdi-arrow-up ml-2"
                  onClick={() => handleOrganization(bankSlips, 'notaMaior')}
                />
                <ModalOrganizationIcon
                  className="mdi mdi-arrow-down ml-2"
                  onClick={() => handleOrganization(bankSlips, 'notaMenor')}
                />
              </div>
            </ModalOrganizationItem>
          </ModalOrganizationContent>
        </ModalOrganizationContainer>
      </Modal>
      {loading ? <Loading /> : null}
    </>
  );
};

export default Notas;
